import { IconButton, Tooltip as MUITooltip } from "@mui/material";
import { FC } from "react";
import { BREAKPOINTS } from "../constants/common";
import { useWindowSize } from "../hooks/useWindowWidth";
import { ReactComponent as CircleInfo } from "../assets/icons/circle-info.svg";
import { translation as t } from "../utils/translation";
interface TooltipProps {
  message: string;
  title?: string;
}
const Tooltip: FC<TooltipProps> = ({ message, title }: TooltipProps) => {
  const windowWidth = useWindowSize();
  const { EXTRA_LARGE } = BREAKPOINTS;
  return (
    <MUITooltip
      title={
        <span
          className={`text-darkBlue font-normal ${
            windowWidth < EXTRA_LARGE ? "text-[16px]" : "text-[18px]"
          }`}
        >
          {message}
        </span>
      }
      placement="top"
      enterTouchDelay={0}
      leaveTouchDelay={10000}
      arrow
    >
      <IconButton disableRipple disableFocusRipple size="small" aria-hidden = "true" role = "presentation">
        {title ? (
          <span
            role={"tooltip"}
            aria-label={`${t.ACCESSIBILITY.MORE_INFO_ABOUT_BUTTON} ${title} ${message}`}
          >
            <CircleInfo />
          </span>
        ) : (
          <CircleInfo />
        )}
      </IconButton>
    </MUITooltip>
  );
};
export default Tooltip;